import React, { useState, ReactNode } from 'react';
import CandleContext from './context';

type CandleContextProviderProps = {
    children: ReactNode;
};

const CandleContextProvider: React.FC<CandleContextProviderProps> = ({ children }) => {
    const [candleCount, setCandleCount] = useState(0);

    return (
        <CandleContext.Provider value={{ candleCount, setCandleCount }}>
            {children}
        </CandleContext.Provider>
    );
};

export default CandleContextProvider;
